import React, { useEffect} from "react";

import { useState } from 'react'
import { Transition } from '@headlessui/react'
import { XCircleIcon,CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { NotificationModel } from "@/models/Notification";
import {remove} from "@/reducers/NotificationReducer";
import store from "@/redux/store";
export default function Notification({...props}) {
  const [show, setShow] = useState(true)
    let notificationHeader = null;
    let notificationMessage = null;
//useEffect(() => {
    if(props?.data?.message?.header) {
        notificationHeader = props?.data?.message?.header;
    } else if(props?.data?.header){
        notificationHeader = props?.data?.header;
    }

    if(props?.data?.message?.message) {
        notificationMessage = props?.data?.message?.message;
    } else if(props?.data?.message){
        notificationMessage = props?.data?.message;
    }
    
    
//}, [props])    

 //useEffect(() => {
    let index = 0
    let timer = null;
    if(props?.data?.secondsToClose > 0) {
        timer = setInterval(() => {
          // Keep the last word
          closeNotification();
        }, (props.data.secondsToClose * 1000))
    }
    
    
    const closeNotification=() => {
          setShow(false);
          if(timer) {
          clearInterval(timer);
          timer = null;
          }
          if(props?.closeNotificationEvent) {
            props.closeNotificationEvent(props.data);
          }
          
    }
//    return () => {
//        if(timer) {clearInterval(timer)}
//    }
//  }, [show])

  return (
      <div
        aria-live="assertive"
        className="pointer-events-none inset-0 flex flex-col items-center  px-4 py-6 sm:items-start sm:p-2"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition show={show}>
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    {props.data && props.data.type && props.data.type == NotificationModel.NOTIFICATION_TYPE.SUCCES && 
                    <CheckCircleIcon aria-hidden="true" className="h-6 w-6 text-green-400" />
                    }
                    {props.data && props.data.type && props.data.type == NotificationModel.NOTIFICATION_TYPE.INFO &&
                    <ExclamationTriangleIcon aria-hidden="true" className="h-6 w-6 text-yellow-400" />
                    }
                    {props.data && props.data.type && props.data.type == NotificationModel.NOTIFICATION_TYPE.ERROR &&
                    <XCircleIcon aria-hidden="true" className="h-6 w-6 text-red-400" />
                    }
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                  {notificationHeader && 
                    <p className="text-sm font-medium text-gray-900" dangerouslySetInnerHTML={{ __html: notificationHeader }}></p>
                    }
                    {notificationMessage &&
                    <p className="mt-1 text-sm text-gray-500" dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
                    }
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      onClick={() => {
                        closeNotification()
                      }}
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
        )
}